<script lang="ts">
  import AuthGate from './components/AuthGate.svelte';
  import AppShell from './components/AppShell.svelte';
</script>

<AuthGate>
  {#snippet children(user)}
    <AppShell {user} />
  {/snippet}
</AuthGate>
